import React, { useRef } from 'react'
import { Input } from 'antd-mobile'
import styles from './index.scss'
import AreaNumber from './areaNumber'
import { DownOutline } from 'antd-mobile-icons'

type PropsType = {
  value?: any
  onChange?: any
  disabled?: boolean
}

const DpCarNumber = (props: PropsType) => {
  const currentInput: any = useRef()
  return (
    <div className={styles['car-number']}>
      <AreaNumber value={props?.value?.[0]} onChange={(v: any) => {
        props?.onChange?.([v?.join(''), props?.value?.[1]])
        currentInput.current?.focus?.()
      }} />
      <span className={styles['car-number-dot']}>·</span>
      <Input ref={(e) => currentInput.current = e} disabled={props?.disabled} value={props?.value?.[1]} style={{ flex: 1 }} onChange={(v) => props?.onChange?.([props?.value?.[0], v])} placeholder='请输入' />
    </div>
  )
}

export default DpCarNumber
